module.exports = __webpack_public_path__ + "assets/img/sea1.7e3a09dc.png";